const ArasQuizVue = {
	init (Vue) {

		/*
		* Aras Quiz - crudely imported to this doc, no refinements added yet
		*/

		if ( $('#app').length ) {
			// Create a quiz object with a title and two questions.
			// A question has one or more answer, and one or more is valid.

			// var q1in=localStorage.getItem("questionone");
			// var q2in=localStorage.getItem("questiontwo");
			// var q3in=localStorage.getItem("questionthree");
			// var q4in=localStorage.getItem("questionfour");
			// var q5in=localStorage.getItem("questionfive");
			// var q6in=localStorage.getItem("questionsix");
			//
			// for (var i = 0; i < 6; i++) {
			//     var quest[i]=localStorage.getItem("question[i]");
			//     var answer1_[i]=localStorage.getItem("questiona1_[i]");
			//     var answer2_[i]=localStorage.getItem("questiona2_[i]");
			//     var answer3_[i]=localStorage.getItem("questiona3_[i]");

			    // localStorage.setItem("question[i]a1",q[i]a1);
			    // localStorage.setItem("question[i]a2",q[i]a2);
			    // localStorage.setItem("question[i]",q[i]a3);
			// }

			// vm.$forceUpdate();

			var q1in=localStorage.getItem("questionone");
			var q2in=localStorage.getItem("questiontwo");
			var q3in=localStorage.getItem("questionthree");
			var q4in=localStorage.getItem("questionfour");
			var q5in=localStorage.getItem("questionfive");
			var q6in=localStorage.getItem("questionsix");

			var q1a1 = localStorage.getItem("q1a1");
			var q1a2 = localStorage.getItem("q1a2");
			var q1a3 = localStorage.getItem("q1a3");

			var q2a1 = localStorage.getItem("q2a1");
			var q2a2 = localStorage.getItem("q2a2");
			var q2a3 = localStorage.getItem("q2a3");

			var q3a1 = localStorage.getItem("q3a1");
			var q3a2 = localStorage.getItem("q3a2");
			var q3a3 = localStorage.getItem("q3a3");

			var q4a1 = localStorage.getItem("q4a1");
			var q4a2 = localStorage.getItem("q4a2");
			var q4a3 = localStorage.getItem("q4a3");

			var q5a1 = localStorage.getItem("q5a1");
			var q5a2 = localStorage.getItem("q5a2");
			var q5a3 = localStorage.getItem("q5a3");

			var q6a1 = localStorage.getItem("q6a1");
			var q6a2 = localStorage.getItem("q6a2");
			var q6a3 = localStorage.getItem("q6a3");

			// var q1b1 = localStorage.getItem("q1b1");
			// var q1b2 = localStorage.getItem("q1b2");
			// var q1b3 = localStorage.getItem("q1b3");
			//
			// var q2b1 = localStorage.getItem("q2b1");
			// var q2b2 = localStorage.getItem("q2b2");
			// var q2b3 = localStorage.getItem("q2b3");
			//
			// var q3b1 = localStorage.getItem("q3b1");
			// var q3b2 = localStorage.getItem("q3b2");
			// var q3b3 = localStorage.getItem("q3b3");
			//
			// var q4b1 = localStorage.getItem("q4b1");
			// var q4b2 = localStorage.getItem("q4b2");
			// var q4b3 = localStorage.getItem("q4b3");
			//
			// var q5b1 = localStorage.getItem("q5b1");
			// var q5b2 = localStorage.getItem("q5b2");
			// var q5b3 = localStorage.getItem("q5b3");
			//
			// var q6b1 = localStorage.getItem("q6b1");
			// var q6b2 = localStorage.getItem("q6b2");
			// var q6b3 = localStorage.getItem("q6b3");



			// alert(q6b3);

			var quiz = {

			  title: 'Aras Kids Quiz',
			  questions: [
			    {
			      title: "Question 1 of 6",
			      text: q1in,
			      responses: [
			        {radio:'Q1-1', text: q1a1, correct: q1b1, checked: false},
			        {radio:'Q1-2', text: q1a2, correct: q1b2, checked: false},
			        {radio:'Q1-3', text: q1a3, correct: q1b3, checked: false}
			      ]
			    }, {
			      title: "Question 2 of 6",
			      text: q2in,
			      responses: [
			        {text: q2a1, radio:'Q2-1', correct: q2b1, checked: false },
			        {text: q2a2, radio:'Q2-2', correct: q2b2, checked: false},
			        {text: q2a3, radio:'Q2-3', correct: q2b3, checked: false}
			      ]
			    },
			    {
			      title: "Question 3 of 6",
			      text: q3in,
			      responses: [
			        {text: q3a1, radio:'Q3-1', correct: q3b1, checked: false},
			        {text: q3a2, radio:'Q3-2', correct: q3b2, checked: false},
			        {text: q3a3, radio:'Q3-4', correct: q3b3, checked: false}
			      ]
			    },
			    {
			      title: "Question 4 of 6",
			      text: q4in,
			      responses: [
			        {text: q4a1, radio:'Q4-1', correct: q4b1, checked: false},
			        {text: q4a2, radio:'Q4-2', correct: q4b2, checked: false},
			        {text: q4a3, radio:'Q4-3', correct: q4b3, checked: false}
			      ]
			    },
			    {
			      title: "Question 5 of 6",
			      text: q5in,
			      responses: [
			        {text: q5a1, radio:'Q5-1', correct: q5b1, checked: false},
			        {text: q5a2, radio:'Q5-3', correct: q5b2, checked: false},
			        {text: q5a3, radio:'Q5-4', correct: q5b3, checked: false}
			      ]
			    },
			    {
			      title: "Question 6 of 6",
			      text: q6in,
			      responses: [
			        {text: q6a1, radio:'Q6-1', correct: q6b1, checked: false},
			        {text: q6a2, radio:'Q6-3', correct: q6b2, checked: false},
			        {text: q6a3, radio:'Q6-4', correct: q6b3, checked: false}
			      ]
			    }
			  ]
			};

			new Vue({
			  el: '#app',
			  data: {
			    has_started:false,
			    // show: false,
			    quiz: quiz,
			    // Store current question index
			    questionIndex: 0,
			    // An array initialized with "false" values for each question
			    // It means: "did the user answered correctly to the question n?" "no".
			    userResponses: Array(quiz.questions).fill(null)
			  },
			  // The view will trigger these methods on click
			  methods: {

			    //start method
			    start: function() {
			      this.has_started = true;
			      this.questionIndex = 0;
			      // this.userResponses[index] = 0;
			      // this.userResponses= null;
			    },
			    // Go to next question
			    next: function() {
			      this.questionIndex++;
			    },
			    // Go to previous question
			    prev: function() {
			      this.questionIndex--;
			    },
			    //resets quiz
			    repeat: function() {
			      this.has_started = false;
			      this.questionIndex = 0;
			      // this.userResponses[0];
			      // this.userResponses = Array(quiz.questions).fill(null);
			    },
			    // Return "true" count in userResponses
			    score: function() {
			    	console.log(this.userResponses);
			    	console.log(this.userResponses.filter(function(val) { return val }).length);
			      return this.userResponses.filter(function(val) { return val }).length;
			    }

			    // beforeEnter: function (el) {
			    //   el.style.opacity = 0
			    // },
			    // enter: function (el, done) {
			    //   Velocity(el, { opacity: 1, fontSize: '1.4em' }, { duration: 300 })
			    //   Velocity(el, { fontSize: '1em' }, { complete: done })
			    // },
			    // leave: function (el, done) {
			    //   Velocity(el, { opacity: 0, fontSize: '1em' }, { duration: 300 })
			    //   Velocity(el, { fontSize: '1.4em' }, { complete: done })
			    // }
			  }
			});

		}

	}
};

export default ArasQuizVue;


// WEBPACK FOOTER //
// ./src/js/aras-kids-modules/aras-kids-quiz.js